import { shouldForwardProp } from '@mui/system';
import { styled, IconButton } from '../../../../base';

const customShouldForwardProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) && !['isActive'].includes(prop as string);

export const StyledToggleButton = styled(IconButton, {
    shouldForwardProp: customShouldForwardProp,
})<{ isActive: boolean }>(({ theme, isActive }) => ({
    borderRadius: theme.shape.borderRadius,
    backgroundColor: 'transparent',
    color: isActive ? theme.palette.secondary.main : theme.palette.grey[400],
    '&:hover': {
        backgroundColor: 'transparent',
        color: isActive
            ? theme.palette.secondary.dark
            : theme.palette.grey[600],
    },
    '&.Mui-disabled': {
        color: theme.palette.grey[300],
    },
}));
